import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { CostElementFormComponent } from './cost-element-form/cost-element-form.component';
import { CostElementsListComponent } from './cost-elements-list/cost-elements-list.component';
import { CostFilterPipe } from './pipe/cost-filter.pipe';

@NgModule({
  declarations: [CostElementsListComponent, CostElementFormComponent, CostFilterPipe],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: []
})
export class CostElementsModule { }
